var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "auto-fetch": false,
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: true,
          "serial-width": "100",
          selection: _vm.hasBtn && _vm.selection,
          stripe: false,
          "right-toolbar-hide": "",
          "hide-search": _vm.hideSearch,
          "row-key": "id",
          "reset-data": _vm.resetDataFn,
          "tree-select-auto-parent": "",
          lazy: "",
          load: _vm.loadMethod,
          "search-btn-hide": true,
          "row-style": _vm.rowStyleFun,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
        },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "tags"
                                      ? [
                                          _c("BjTagList", {
                                            attrs: {
                                              "tag-code-string": scope.row.tags,
                                            },
                                          }),
                                        ]
                                      : col.prop === "standardSkuCode"
                                      ? [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toView(scope.row)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.standardSkuCode
                                                )
                                              ),
                                            ]
                                          ),
                                          scope.row.standardSkuCode
                                            ? _c("BjCopyIcon", {
                                                attrs: {
                                                  copy: scope.row
                                                    .standardSkuCode,
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      : col.prop === "deliveryTime"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row[col.prop]) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "refundFlag"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: scope.row.refundFlag
                                                  ? "success"
                                                  : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.STATUS_YES_NUM.bjGet(
                                                      !!scope.row.refundFlag
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop
                                          .toLocaleLowerCase()
                                          .includes("amount") ||
                                        col.prop
                                          .toLocaleLowerCase()
                                          .includes("price")
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$number2money(
                                                  scope.row[col.prop]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "deliveryStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST.concat(
                                                    _vm.ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST
                                                  ).bjGet(scope.row[col.prop])
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "receivingStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST.concat(
                                                    _vm.ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST
                                                  ).bjGet(scope.row[col.prop])
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "preemptionStatus"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              style:
                                                "color:" +
                                                (scope.row.isColorRed
                                                  ? "red"
                                                  : ""),
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST.concat(
                                                        _vm.ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST
                                                      ).bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "sourceStatus"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              style:
                                                "color:" +
                                                (scope.row.isColorRed
                                                  ? "red"
                                                  : ""),
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST.concat(
                                                        _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST
                                                      ).bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "syncPreempStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST.concat(
                                                    _vm.ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST
                                                  ).bjGet(scope.row[col.prop])
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "suspendStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST.concat(
                                                    _vm.ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST
                                                  ).bjGet(scope.row[col.prop])
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "syncDeliveryStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST.concat(
                                                    _vm.ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST
                                                  ).bjGet(scope.row[col.prop])
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDetail(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("viewDialog", { ref: "viewDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }